export default [
	{
		id: "room_1",
		bedNumber: "Room 1",
	},
	{
		id: "1.1",
		room: "1",
		parent: "room_1",
		bedNumber: "Bed 1",

		status: "occupied",
		patientName: "Julia Howard",
		patientHeight: "1.78",
		patientWeight: "56",
		diagnosis: "Pneumonia",
		patientTemperature: 37.3,
		bloodPressure: "90/60",
		careRequired: "Take samples",
		doctor: "Nancy Newman",
		admission: "12/12/2020",
		controls: ["edit", "clear"],

		insuranceType: "PPO",
		planNumber: "2020/12ABS-PPO",
		policyHolderDate: "08/03/1990",
		policyHolderName: "Jamy Hernez",
		policyHolderRelationship: "brother",
		policyIdNumber: "ZGP112243546",
		emergencyContactCity: "Washington, D.C",
		emergencyContactCountry: "USA",
		emergencyContactName: "Jamy Hernez",
		emergencyFirstContactNumber: "+12029607849",
		emergencySecondContactNumber: "+12029611832",
		relationship: "brother",
		adress: "600 Independence Ave SW, Washington, DC 20560, USA",
		city: "Washington, D.C",
		country: "USA",
		email: "jamy@mail.com",
		firstContactNumber: "+12029607849",
		secondContactNumber: "+12029611832",
		patientAllergies: "none",
		patientBloodGroup: "A-",
		patientChronicCondition: "none",
		patientDateBrith: "12/03/1991",
		patientEmployer: "IBM",
		patientEmploymentStatus: "employee",
		patientGender: "female",
		patientId: "FG00012020",
		patientNationality: "United States of America",
		patientOccupation: "Software engineer",
		patientReligion: "Christian",
	},
	{
		id: "1.2",
		room: "1",
		parent: "room_1",
		bedNumber: "Bed 2",

		status: "occupied",
		patientName: "Danny D. Perkins",
		patientHeight: "1.73",
		patientWeight: "78",
		diagnosis: "Pneumonia",
		patientTemperature: 38.3,
		bloodPressure: "140/90",
		careRequired: "Give medications",
		doctor: "Nancy Newman",
		admission: "12/12/2020",
		controls: ["edit", "clear"],

		insuranceType: "POS",
		planNumber: "789320",
		policyHolderDate: "10/10/1975",
		policyHolderName: "Jeffery Perkins",
		policyHolderRelationship: "son",
		policyIdNumber: "ZGN003719500",
		emergencyContactCity: "Hillside",
		emergencyContactCountry: "USA",
		emergencyContactName: "Jeffery Perkins",
		emergencyFirstContactNumber: "+12025550154",
		emergencySecondContactNumber: "+12029611832",
		relationship: "son",
		adress: "1444 Orchard Ter, Hillside, New Jersey(NJ), 07205",
		city: "Hillside",
		country: "USA",
		email: "DannyDPerkins@jourrapide.com",
		firstContactNumber: "+12025551088",
		secondContactNumber: "+12025550127",
		patientAllergies: "none",
		patientBloodGroup: "B+",
		patientChronicCondition: "Arthritis, diabetes",
		patientDateBrith: "10/08/1944",
		patientEmployer: "Chandlers",
		patientEmploymentStatus: "worker",
		patientGender: "male",
		patientId: "FG00012021",
		patientNationality: "USA",
		patientOccupation: "Tour bus driver",
		patientReligion: "Christian",
	},
	{
		id: "1.3",
		room: "1",
		parent: "room_1",
		bedNumber: "Bed 3",

		status: "occupied",
		patientName: "Ed H. Birch",
		patientHeight: "1.73",
		patientWeight: "77",
		diagnosis: "Pneumonia",
		patientTemperature: 39.1,
		bloodPressure: "130/80",
		careRequired: "Take samples",
		doctor: "Nancy Newman",
		admission: "12/12/2020",
		controls: ["edit", "clear"],

		insuranceType: "HMO",
		planNumber: "640325",
		policyHolderDate: "11/02/1947",
		policyHolderName: "Ed H. Birch",
		policyHolderRelationship: "-",
		policyIdNumber: "YKQ203042790",
		emergencyContactCity: "Tuscaloosa",
		emergencyContactCountry: "USA",
		emergencyContactName: "Claude Brock",
		emergencyFirstContactNumber: "+12025550141",
		emergencySecondContactNumber: "+12025550114",
		relationship: "nephew",
		adress: "4908 25th St Tuscaloosa, Alabama (AL), 35401",
		city: "Tuscaloosa",
		country: "USA",
		email: "EdHBirch@rhyta.com",
		firstContactNumber: "+12025550114",
		secondContactNumber: "+12025550142",
		patientAllergies: "peanuts",
		patientBloodGroup: "B-",
		patientChronicCondition: "Heart disease",
		patientDateBrith: "11/02/1947",
		patientEmployer: "Sunflower Market",
		patientEmploymentStatus: "employee",
		patientGender: "male",
		patientId: "FG00012022",
		patientNationality: "United States of America",
		patientOccupation: "Facilitator",
		patientReligion: "Atheist",
	},
	{
		id: "1.4",
		room: "1",
		parent: "room_1",
		bedNumber: "Bed 4",

		status: "available",
		patientName: "-",
		patientHeight: "",
		patientWeight: "",
		diagnosis: "-",
		patientTemperature: "",
		bloodPressure: "",
		careRequired: "-",
		doctor: "-",
		admission: "",
		controls: ["edit", "clear"],
	},
	{
		id: "room_2",
		bedNumber: "Room 2",
	},
	{
		id: "2.1",
		room: "2",
		parent: "room_2",
		bedNumber: "Bed 1",

		status: "occupied",
		patientName: "Kevin Grasty",
		patientHeight: "1.73",
		patientWeight: "123",
		diagnosis: "Flu",
		patientTemperature: 39.8,
		bloodPressure: "110/60",
		careRequired: "Give medications",
		doctor: "Nancy Newman",
		admission: "12/12/2020",
		controls: ["edit", "clear"],

		insuranceType: "HSA",
		planNumber: "132132",
		policyHolderDate: "09/05/1981",
		policyHolderName: "Kevin Grasty",
		policyHolderRelationship: "-",
		policyIdNumber: "9114548503100",
		emergencyContactCity: "Pollok",
		emergencyContactCountry: "USA",
		emergencyContactName: "Beth Grasty",
		emergencyFirstContactNumber: "+12029607849",
		emergencySecondContactNumber: "+12029611832",
		relationship: "wife",
		adress: "264 Dogwood Ln, Pollok, Texas (TX), 75969",
		city: "Pollok",
		country: "USA",
		email: "KevinEGrasty@teleworm.us",
		firstContactNumber: "+12025550127",
		secondContactNumber: "+12025550167",
		patientAllergies: "none",
		patientBloodGroup: "O-",
		patientChronicCondition: "none",
		patientDateBrith: "09/05/1981",
		patientEmployer: "Grass Roots Yard Services",
		patientEmploymentStatus: "worker",
		patientGender: "male",
		patientId: "FG00012023",
		patientNationality: "Poland",
		patientOccupation: "Phlebotomist",
		patientReligion: "Christian",
	},
	{
		id: "2.2",
		room: "2",
		parent: "room_2",
		bedNumber: "Bed 2",

		status: "occupied",
		patientName: "George Sawyer",
		patientHeight: "2.06",
		patientWeight: "81",
		diagnosis: "Flu",
		patientTemperature: 40.1,
		bloodPressure: "150/85",
		careRequired: "Take samples",
		doctor: "Archie Barnes",
		admission: "12/12/2020",
		controls: ["edit", "clear"],

		insuranceType: "POS",
		planNumber: "235689",
		policyHolderDate: "09/12/1978",
		policyHolderName: "George Sawyer",
		policyHolderRelationship: "-",
		policyIdNumber: "MLN2804307912",
		emergencyContactCity: "Hartwell",
		emergencyContactCountry: "USA",
		emergencyContactName: "Wendy Jackson",
		emergencyFirstContactNumber: "+12029607849",
		emergencySecondContactNumber: "+12029611832",
		relationship: "sister",
		adress: "116 Haley Rd Kittery, Maine(ME), 03904",
		city: "Kittery",
		country: "USA",
		email: "GeorgePSawyer@jourrapide.com",
		firstContactNumber: "+12025550108",
		secondContactNumber: "+12025550144",
		patientAllergies: "none",
		patientBloodGroup: "A+",
		patientChronicCondition: "Asthma",
		patientDateBrith: "09/12/1978",
		patientEmployer: "S&W Cafeteria",
		patientEmploymentStatus: "contractor",
		patientGender: "male",
		patientId: "FG00012024",
		patientNationality: "United States of America",
		patientOccupation: "Studio camera operator",
		patientReligion: "Hinduist",
	},
	{
		id: "2.3",
		room: "2",
		parent: "room_2",
		bedNumber: "Bed 3",

		status: "available",
		patientName: "-",
		patientHeight: "",
		patientWeight: "",
		diagnosis: "-",
		patientTemperature: "",
		bloodPressure: "",
		careRequired: "-",
		doctor: "-",
		admission: "",
		controls: ["edit", "clear"],
	},
	{
		id: "2.4",
		room: "2",
		parent: "room_2",
		bedNumber: "Bed 4",

		status: "available",
		patientName: "-",
		patientHeight: "",
		patientWeight: "",
		diagnosis: "-",
		patientTemperature: "",
		bloodPressure: "",
		careRequired: "-",
		doctor: "-",
		admission: "",
		controls: ["edit", "clear"],
	},
	{
		id: "room_3",
		bedNumber: "Room 3",
	},
	{
		id: "3.1",
		room: "3",
		parent: "room_3",
		bedNumber: "Bed 1",

		status: "occupied",
		patientName: "Luis Heer",
		patientHeight: "1.85",
		patientWeight: "91",
		diagnosis: "Flu",
		patientTemperature: 37.8,
		bloodPressure: "120/75",
		careRequired: "Prep for surgery",
		doctor: "Jenson Brown",
		admission: "12/12/2020",
		controls: ["edit", "clear"],

		insuranceType: "PPO",
		planNumber: "2020/12ABS-PPO",
		policyHolderDate: "02/03/1992",
		policyHolderName: "Susie Thornton",
		policyHolderRelationship: "daughter",
		policyIdNumber: "ZQY0175463810",
		emergencyContactCity: "Canton",
		emergencyContactCountry: "USA",
		emergencyContactName: "Susie Thornton",
		emergencyFirstContactNumber: "+12025553194",
		emergencySecondContactNumber: "+12025550171",
		relationship: "daughter",
		adress: "115 Dakota St Callaway, Minnesota (MN), 56521",
		city: "Callaway",
		country: "USA",
		email: "LuisMHeer@dayrep.com",
		firstContactNumber: "+12025550148",
		secondContactNumber: "+12039345149",
		patientAllergies: "none",
		patientBloodGroup: "B-",
		patientChronicCondition: "Osteoporosis",
		patientDateBrith: "07/10/1964",
		patientEmployer: "Hoyden",
		patientEmploymentStatus: "employee",
		patientGender: "male",
		patientId: "FG00012024",
		patientNationality: "United States of America",
		patientOccupation: "Adult literacy teacher",
		patientReligion: "Christian",
	},
	{
		id: "3.2",
		room: "3",
		parent: "room_3",
		bedNumber: "Bed 2",

		status: "occupied",
		patientName: "John M. Drake",
		patientHeight: "1.91",
		patientWeight: "87",
		diagnosis: "Bronchitis",
		patientTemperature: 38.3,
		bloodPressure: "115/70",
		careRequired: "Prep for surgery",
		doctor: "Jenson Brown",
		admission: "12/12/2020",
		controls: ["edit", "clear"],

		insuranceType: "HRAs",
		planNumber: "651439",
		policyHolderDate: "12/10/1974",
		policyHolderName: "John M. Drake",
		policyHolderRelationship: "-",
		policyIdNumber: "ZQR9086678800",
		emergencyContactCity: "Knightstown",
		emergencyContactCountry: "USA",
		emergencyContactName: "Claire Doyle",
		emergencyFirstContactNumber: "+12025545194",
		emergencySecondContactNumber: "+12025565199",
		relationship: "sister",
		adress: "26 Aspen Cir, Barnegat, New Jersey (NJ), 08005",
		city: "Barnegat",
		country: "USA",
		email: "JohnMDrake@jourrapide.com",
		firstContactNumber: "+12025550180",
		secondContactNumber: "+12025550182",
		patientAllergies: "seasonal allergic rhinitis",
		patientBloodGroup: "O+",
		patientChronicCondition: "none",
		patientDateBrith: "12/10/1974",
		patientEmployer: "Witmark",
		patientEmploymentStatus: "worker",
		patientGender: "male",
		patientId: "FG00012025",
		patientNationality: "United States of America",
		patientOccupation: "Rolling machine operator",
		patientReligion: "Christian",
	},
	{
		id: "3.3",
		room: "3",
		parent: "room_3",
		bedNumber: "Bed 3",

		status: "occupied",
		patientName: "Robert R. Reich",
		patientHeight: "1.75",
		patientWeight: "74",
		diagnosis: "Bronchitis",
		patientTemperature: 37.9,
		bloodPressure: "135/80",
		careRequired: "Prep for surgery",
		doctor: "Jenson Brown",
		admission: "12/12/2020",
		controls: ["edit", "clear"],

		insuranceType: "POS",
		planNumber: "190342",
		policyHolderDate: "03/03/1985",
		policyHolderName: "Robert R. Reich",
		policyHolderRelationship: "-",
		policyIdNumber: "RPL3029576303",
		emergencyContactCity: "Warsaw",
		emergencyContactCountry: "USA",
		emergencyContactName: "Ronald Young",
		emergencyFirstContactNumber: "+12025055190",
		emergencySecondContactNumber: "+12021555197",
		relationship: "brother-in-law",
		adress: "391 Old Mamaroneck Rd, White Plains, New York (NY), 10605",
		city: "White Plains",
		country: "USA",
		email: "RobertRReich@jourrapide.com",
		firstContactNumber: "+12025550143",
		secondContactNumber: "+12025550165",
		patientAllergies: "shellfish",
		patientBloodGroup: "A+",
		patientChronicCondition: "none",
		patientDateBrith: "03/03/1985",
		patientEmployer: "Team Uno",
		patientEmploymentStatus: "office holder",
		patientGender: "male",
		patientId: "FG00012027",
		patientNationality: "United States of America",
		patientOccupation: "Travel adviser",
		patientReligion: "Christian",
	},
	{
		id: "3.4",
		room: "3",
		parent: "room_3",
		bedNumber: "Bed 4",

		status: "available",
		patientName: "-",
		patientHeight: "",
		patientWeight: "",
		diagnosis: "-",
		patientTemperature: "",
		bloodPressure: "",
		careRequired: "-",
		doctor: "-",
		admission: "",
		controls: ["edit", "clear"],
	},
	{
		id: "room_4",
		bedNumber: "Room 4",
	},
	{
		id: "4.1",
		room: "4",
		parent: "room_4",
		bedNumber: "Bed 1",

		status: "occupied",
		patientName: "Cathy Bower",
		patientHeight: "1.85",
		patientWeight: "95",
		diagnosis: "Sinusitis",
		patientTemperature: 37.4,
		bloodPressure: "120/70",
		careRequired: "Prep for surgery",
		doctor: "Abraham Johnston",
		admission: "12/12/2020",
		controls: ["edit", "clear"],

		insuranceType: "EPOSe",
		planNumber: "190342",
		policyHolderDate: "09/03/1975",
		policyHolderName: "Cathy Bower",
		policyHolderRelationship: "-",
		policyIdNumber: "RPL3029576303",
		emergencyContactCity: "Potomac",
		emergencyContactCountry: "USA",
		emergencyContactName: "Stacey Bailey",
		emergencyFirstContactNumber: "+12025552187",
		emergencySecondContactNumber: "+12025553180",
		relationship: "sister",
		adress: "18122 E Pne, Riverview, Michigan (MI), 48193",
		city: "Riverview",
		country: "USA",
		email: "CathyJBower@rhyta.com",
		firstContactNumber: "+12025550132",
		secondContactNumber: "+12025550104",
		patientAllergies: "none",
		patientBloodGroup: "AB-",
		patientChronicCondition: "Arthritis",
		patientDateBrith: "09/03/1975",
		patientEmployer: "Simply Appraisals",
		patientEmploymentStatus: "employee",
		patientGender: "female",
		patientId: "FG00012028",
		patientNationality: "United States of America",
		patientOccupation: "Dermatology nurse",
		patientReligion: "Christian",
	},
	{
		id: "4.2",
		room: "4",
		parent: "room_4",
		bedNumber: "Bed 2",

		status: "available",
		patientName: "-",
		patientHeight: "",
		patientWeight: "",
		diagnosis: "-",
		patientTemperature: "",
		bloodPressure: "",
		careRequired: "-",
		doctor: "-",
		admission: "",
		controls: ["edit", "clear"],
	},
	{
		id: "4.3",
		room: "4",
		parent: "room_4",
		bedNumber: "Bed 3",

		status: "available",
		patientName: "-",
		patientHeight: "",
		patientWeight: "",
		diagnosis: "-",
		patientTemperature: "",
		bloodPressure: "",
		careRequired: "-",
		doctor: "-",
		admission: "",
		controls: ["edit", "clear"],
	},
	{
		id: "4.4",
		room: "4",
		parent: "room_4",
		bedNumber: "Bed 4",

		status: "available",
		patientName: "-",
		patientHeight: "",
		patientWeight: "",
		diagnosis: "-",
		patientTemperature: "",
		bloodPressure: "",
		careRequired: "-",
		doctor: "-",
		admission: "",
		controls: ["edit", "clear"],
	},
	{
		id: "room_5",
		bedNumber: "Room 5",
	},
	{
		id: "5.1",
		room: "5",
		parent: "room_5",
		bedNumber: "Bed 1",

		status: "occupied",
		patientName: "Melissa Baker",
		patientHeight: "1.75",
		patientWeight: "98",
		diagnosis: "Pneumonia",
		patientTemperature: 37.6,
		bloodPressure: "110/70",
		careRequired: "Take samples",
		doctor: "Abraham Johnston",
		admission: "12/12/2020",
		controls: ["edit", "clear"],

		insuranceType: "PPO",
		planNumber: "908540",
		policyHolderDate: "12/12/1989",
		policyHolderName: "Melissa Baker",
		policyHolderRelationship: "-",
		policyIdNumber: "ZPJ0029652000",
		emergencyContactCity: "Wyandanch",
		emergencyContactCountry: "USA",
		emergencyContactName: "Kyle Higgins",
		emergencyFirstContactNumber: "+12027555131",
		emergencySecondContactNumber: "+12025595133",
		relationship: "ex-husband",
		adress: "1929 Manning Hwy, Greeleyville, South Carolina(SC), 29056",
		city: "Greeleyville",
		country: "USA",
		email: "MelissaMBaker@armyspy.com",
		firstContactNumber: "+12025550116",
		secondContactNumber: "+12025550193",
		patientAllergies: "none",
		patientBloodGroup: "AB+",
		patientChronicCondition: "none",
		patientDateBrith: "12/12/1989",
		patientEmployer: "Consumers Food and Drug",
		patientEmploymentStatus: "director",
		patientGender: "female",
		patientId: "FG00012029",
		patientNationality: "United States of America",
		patientOccupation: "CCO",
		patientReligion: "Christian",
	},
	{
		id: "5.2",
		room: "5",
		parent: "room_5",
		bedNumber: "Bed 2",

		status: "occupied",
		patientName: "Arham Akel",
		patientHeight: "2.03",
		patientWeight: "74",
		diagnosis: "Pneumonia",
		patientTemperature: 37.3,
		bloodPressure: "115/90",
		careRequired: "Take samples",
		doctor: "Abraham Johnston",
		admission: "12/12/2020",
		controls: ["edit", "clear"],

		insuranceType: "HSA",
		planNumber: "236548",
		policyHolderDate: "07/02/2000",
		policyHolderName: "Arham Akel",
		policyHolderRelationship: "-",
		policyIdNumber: "KSL2099563210",
		emergencyContactCity: "Saint Cloud",
		emergencyContactCountry: "USA",
		emergencyContactName: "Elvira Wood",
		emergencyFirstContactNumber: "+12025550152",
		emergencySecondContactNumber: "+12025550185",
		relationship: "girlfriend",
		adress: "436 22nd Ave N, Saint Cloud, Minnesota(MN), 56303",
		city: "Saint Cloud",
		country: "USA",
		email: "jamy@mail.com",
		firstContactNumber: "+12029607849",
		secondContactNumber: "+12029611832",
		patientAllergies: "none",
		patientBloodGroup: "A-",
		patientChronicCondition: "none",
		patientDateBrith: "07/02/2000",
		patientEmployer: "Elek-Tek",
		patientEmploymentStatus: "employee",
		patientGender: "female",
		patientId: "FG00012020",
		patientNationality: "United States of America",
		patientOccupation: "Tumbling barrel painter",
		patientReligion: "Muslim",
	},
	{
		id: "5.3",
		room: "5",
		parent: "room_5",
		bedNumber: "Bed 3",

		status: "occupied",
		patientName: "Debra K. Richardson",
		patientHeight: "1.88",
		patientWeight: "77",
		diagnosis: "Pneumonia",
		patientTemperature: 38.3,
		bloodPressure: "110/60",
		careRequired: "Take samples",
		doctor: "Bradley Sutton",
		admission: "12/12/2020",
		controls: ["edit", "clear"],

		insuranceType: "HMO",
		planNumber: "235683",
		policyHolderDate: "09/03/1990",
		policyHolderName: "Charlie Richardson",
		policyHolderRelationship: "son",
		policyIdNumber: "RCS1993578913",
		emergencyContactCity: "Holly Oak",
		emergencyContactCountry: "USA",
		emergencyContactName: "Charlie Richardson",
		emergencyFirstContactNumber: "+12022555188",
		emergencySecondContactNumber: "+12023555189",
		relationship: "son",
		adress: "44 Aaron Smith Drive Camp Hill, Pennsylvania (PA) 17011",
		city: "Camp Hill",
		country: "USA",
		email: "DebraKRichardson@teleworm.us",
		firstContactNumber: "+12025550147",
		secondContactNumber: "+12025550121",
		patientAllergies: "none",
		patientBloodGroup: "B-",
		patientChronicCondition: "adenitis",
		patientDateBrith: "03/08/1966",
		patientEmployer: "Britches of Georgetown",
		patientEmploymentStatus: "employee",
		patientGender: "female",
		patientId: "FG00012031",
		patientNationality: "United States of America",
		patientOccupation: "Payroll and benefits specialist",
		patientReligion: "Christian",
	},
	{
		id: "5.4",
		room: "5",
		parent: "room_5",
		bedNumber: "Bed 4",

		status: "occupied",
		patientName: "Harry Baynes",
		patientHeight: "1.73",
		patientWeight: "91",
		diagnosis: "Pneumonia",
		patientTemperature: 37.2,
		bloodPressure: "115/70",
		careRequired: "Take samples",
		doctor: "Bradley Sutton",
		admission: "12/12/2020",
		controls: ["edit", "clear"],

		insuranceType: "PPO",
		planNumber: "332156",
		policyHolderDate: "08/11/1945",
		policyHolderName: "Harry Baynes",
		policyHolderRelationship: "-",
		policyIdNumber: "CVB1832999811",
		emergencyContactCity: "Miami",
		emergencyContactCountry: "USA",
		emergencyContactName: "Liam Cyril",
		emergencyFirstContactNumber: "+12020555111",
		emergencySecondContactNumber: "+12029555112",
		relationship: "friend",
		adress: "25 Kildeer Drive Pompano Beach, Florida (FL) 33064",
		city: "Pompano Beach",
		country: "USA",
		email: "HarryBaynes@dayrep.com",
		firstContactNumber: "+12025550113",
		secondContactNumber: "+12025550146",
		patientAllergies: "pollen",
		patientBloodGroup: "B-",
		patientChronicCondition: "none",
		patientDateBrith: "08/11/1945",
		patientEmployer: "Federated Group",
		patientEmploymentStatus: "contractor",
		patientGender: "male",
		patientId: "FG00012032",
		patientNationality: "Australia",
		patientOccupation: "Automation and control technician",
		patientReligion: "Christian",
	},
	{
		id: "room_6",
		bedNumber: "Room 6",
	},
	{
		id: "6.1",
		room: "6",
		parent: "room_6",
		bedNumber: "Bed 1",

		status: "occupied",
		patientName: "Paul Bazile",
		patientHeight: "1.6",
		patientWeight: "69",
		diagnosis: "Pneumonia",
		patientTemperature: 36.8,
		bloodPressure: "120/70",
		careRequired: "Post-operation care",
		doctor: "Milena Hunter",
		admission: "12/12/2020",
		controls: ["edit", "clear"],

		insuranceType: "POS",
		planNumber: "234565",
		policyHolderDate: "03/03/1963",
		policyHolderName: "Victoria Bazile",
		policyHolderRelationship: "sister",
		policyIdNumber: "CPN9873444901",
		emergencyContactCity: "Little Tuscon",
		emergencyContactCountry: "USA",
		emergencyContactName: "Victoria Bazile",
		emergencyFirstContactNumber: "+12020555884",
		emergencySecondContactNumber: "+12021555886",
		relationship: "sister",
		adress: "4233 Elk Rd Little Tucson, Arizona (AZ) 85716",
		city: "Little Tucson",
		country: "USA",
		email: "PaulBazile@dayrep.com",
		firstContactNumber: "+12025550120",
		secondContactNumber: "+12025550775",
		patientAllergies: "none",
		patientBloodGroup: "O-",
		patientChronicCondition: "none",
		patientDateBrith: "02/03/1958",
		patientEmployer: "The Wall",
		patientEmploymentStatus: "employee",
		patientGender: "male",
		patientId: "FG00012033",
		patientNationality: "United States of America",
		patientOccupation: "Mental health aide",
		patientReligion: "Christian",
	},
	{
		id: "6.2",
		room: "6",
		parent: "room_6",
		bedNumber: "Bed 2",

		status: "occupied",
		patientName: "Janina Schaefer",
		patientHeight: "1.8",
		patientWeight: "59",
		diagnosis: "Pneumonia",
		patientTemperature: 37.3,
		bloodPressure: "90/60",
		careRequired: "Post-operation care",
		doctor: "Milena Hunter",
		admission: "12/12/2020",
		controls: ["edit", "clear"],

		insuranceType: "PPO",
		planNumber: "234674",
		policyHolderDate: "05/10/1969",
		policyHolderName: "Janina Schaefer",
		policyHolderRelationship: "-",
		policyIdNumber: "DFG5763443421",
		emergencyContactCity: "Perryton",
		emergencyContactCountry: "USA",
		emergencyContactName: "Sophie Schaefer",
		emergencyFirstContactNumber: "+12022555145",
		emergencySecondContactNumber: "+12022555146",
		relationship: "daughter",
		adress: "121 Valley Lane Austin, Texas (TX) 78704",
		city: "Austin",
		country: "USA",
		email: "JaninaSchaefer@jourrapide.com",
		firstContactNumber: "+12025550325",
		secondContactNumber: "+12025550199",
		patientAllergies: "none",
		patientBloodGroup: "AB-",
		patientChronicCondition: "anhidrosis",
		patientDateBrith: "05/10/1969",
		patientEmployer: "Food Fair",
		patientEmploymentStatus: "director",
		patientGender: "female",
		patientId: "FG00012034",
		patientNationality: "Germany",
		patientOccupation: "Residential advisor",
		patientReligion: "Christian",
	},
	{
		id: "6.3",
		room: "6",
		parent: "room_6",
		bedNumber: "Bed 3",

		status: "available",
		patientName: "-",
		patientHeight: "",
		patientWeight: "",
		diagnosis: "-",
		patientTemperature: "",
		bloodPressure: "",
		careRequired: "-",
		doctor: "-",
		admission: "",
		controls: ["edit", "clear"],
	},
	{
		id: "6.4",
		room: "6",
		parent: "room_6",
		bedNumber: "Bed 4",

		status: "available",
		patientName: "-",
		patientHeight: "",
		patientWeight: "",
		diagnosis: "-",
		patientTemperature: "",
		bloodPressure: "",
		careRequired: "-",
		doctor: "-",
		admission: "",
		controls: ["edit", "clear"],
	},
	{
		id: "room_7",
		bedNumber: "Room 7",
	},
	{
		id: "7.1",
		room: "7",
		parent: "room_7",
		bedNumber: "Bed 1",

		status: "occupied",
		patientName: "Pelegrino Ávila Palacios",
		patientHeight: "1.91",
		patientWeight: "97",
		diagnosis: "Pneumonia",
		patientTemperature: 36.3,
		bloodPressure: "110/65",
		careRequired: "Take samples",
		doctor: "Milena Hunter",
		admission: "12/12/2020",
		controls: ["edit", "clear"],

		insuranceType: "HRAs",
		planNumber: "284090",
		policyHolderDate: "01/04/1970",
		policyHolderName: "Albertina Rivera",
		policyHolderRelationship: "friend",
		policyIdNumber: "DFG5474387342",
		emergencyContactCity: "Orlando",
		emergencyContactCountry: "USA",
		emergencyContactName: "Albertina Rivera",
		emergencyFirstContactNumber: "+12020555132",
		emergencySecondContactNumber: "+12021555134",
		relationship: "friend",
		adress: "1444 Sunburst Drive Fort Myers, Florida (FL) 33901",
		city: "Fort Myers",
		country: "USA",
		email: "PelegrinoAvilaPalacios@jourrapide.com",
		firstContactNumber: "+12025550765",
		secondContactNumber: "+12025550223",
		patientAllergies: "none",
		patientBloodGroup: "A+",
		patientChronicCondition: "none",
		patientDateBrith: "06/06/1959",
		patientEmployer: "Carl Durfees",
		patientEmploymentStatus: "employee",
		patientGender: "female",
		patientId: "FG00012035",
		patientNationality: "Spain",
		patientOccupation: "Reservation and transportation ticket agent",
		patientReligion: "Christian",
	},
	{
		id: "7.2",
		room: "7",
		parent: "room_7",
		bedNumber: "Bed 2",

		status: "occupied",
		patientName: "Isabel Evans",
		patientHeight: "1.68",
		patientWeight: "122",
		diagnosis: "Pneumonia",
		patientTemperature: 37.1,
		bloodPressure: "130/80",
		careRequired: "Take samples",
		doctor: "Milena Hunter",
		admission: "12/12/2020",
		controls: ["edit", "clear"],

		insuranceType: "HMO",
		planNumber: "398039",
		policyHolderDate: "03/04/1973",
		policyHolderName: "Martin Evans",
		policyHolderRelationship: "brother",
		policyIdNumber: "HTM5532387234",
		emergencyContactCity: "Cedar Rapids",
		emergencyContactCountry: "USA",
		emergencyContactName: "Martin Evans",
		emergencyFirstContactNumber: "+12025055175",
		emergencySecondContactNumber: "+12025555176",
		relationship: "brother",
		adress: "2856 Woodland Drive Sergeant Bluff, Iowa (IA) 51054",
		city: "Sergeant Bluff",
		country: "USA",
		email: "IsabelEvans@armyspy.com",
		firstContactNumber: "+12025550548",
		secondContactNumber: "+12025550376",
		patientAllergies: "mushrooms",
		patientBloodGroup: "B-",
		patientChronicCondition: "none",
		patientDateBrith: "06/10/1977",
		patientEmployer: "Purity Supreme",
		patientEmploymentStatus: "employee",
		patientGender: "female",
		patientId: "FG00012036",
		patientNationality: "United States of America",
		patientOccupation: "Cost accountant",
		patientReligion: "Christian",
	},
	{
		id: "7.3",
		room: "7",
		parent: "room_7",
		bedNumber: "Bed 3",

		status: "available",
		patientName: "-",
		patientHeight: "",
		patientWeight: "",
		diagnosis: "-",
		patientTemperature: "",
		bloodPressure: "",
		careRequired: "-",
		doctor: "-",
		admission: "",
		controls: ["edit", "clear"],
	},
	{
		id: "7.4",
		room: "7",
		parent: "room_7",
		bedNumber: "Bed 4",

		status: "available",
		patientName: "-",
		patientHeight: "",
		patientWeight: "",
		diagnosis: "-",
		patientTemperature: "",
		bloodPressure: "",
		careRequired: "-",
		doctor: "-",
		admission: "",
		controls: ["edit", "clear"],
	},
	{
		id: "room_8",
		bedNumber: "Room 8",
	},
	{
		id: "8.1",
		room: "8",
		parent: "room_8",
		bedNumber: "Bed 1",

		status: "occupied",
		patientName: "Annie McNeal",
		patientHeight: "1.83",
		patientWeight: "83",
		diagnosis: "Bronchitis",
		patientTemperature: 37.6,
		bloodPressure: "120/75",
		careRequired: "Post-operation care",
		doctor: "Sophia Matthews",
		admission: "12/12/2020",
		controls: ["edit", "clear"],

		insuranceType: "EPOSe",
		planNumber: "450923",
		policyHolderDate: "08/03/1980",
		policyHolderName: "Annie McNeal",
		policyHolderRelationship: "-",
		policyIdNumber: "DCT7812349879",
		emergencyContactCity: "Cambridge",
		emergencyContactCountry: "USA",
		emergencyContactName: "Courtney Flavin",
		emergencyFirstContactNumber: "+12027552309",
		emergencySecondContactNumber: "+12029552301",
		relationship: "friend",
		adress: "1343 Stanton Hollow Road Worcester, Massachusetts (MA) 01610",
		city: "Worcester",
		country: "USA",
		email: "AnnieMcNeal@dayrep.com",
		firstContactNumber: "+12025550396",
		secondContactNumber: "+12025550113",
		patientAllergies: "none",
		patientBloodGroup: "AB-",
		patientChronicCondition: "none",
		patientDateBrith: "08/03/1980",
		patientEmployer: "Pro-Care Garden Maintenance",
		patientEmploymentStatus: "contractor",
		patientGender: "female",
		patientId: "FG00012037",
		patientNationality: "United States of America",
		patientOccupation: "Marine surveyor",
		patientReligion: "Christian",
	},
	{
		id: "8.2",
		room: "8",
		parent: "room_8",
		bedNumber: "Bed 2",

		status: "occupied",
		patientName: "Karen Burgess",
		patientHeight: "1.75",
		patientWeight: "91",
		diagnosis: "Bronchitis",
		patientTemperature: 37.0,
		bloodPressure: "120/60",
		careRequired: "Post-operation care",
		doctor: "Sophia Matthews",
		admission: "12/12/2020",
		controls: ["edit", "clear"],

		insuranceType: "PPO",
		planNumber: "345847",
		policyHolderDate: "02/09/1982",
		policyHolderName: "Karen Burgess",
		policyHolderRelationship: "-",
		policyIdNumber: "CVB2340985769",
		emergencyContactCity: "Villas",
		emergencyContactCountry: "USA",
		emergencyContactName: "Ryan Deluna",
		emergencyFirstContactNumber: "+12020554308",
		emergencySecondContactNumber: "+120209611832",
		relationship: "friend",
		adress: "716 Jadewood Farms Piscataway, New Jersey (NJ) 08854",
		city: "Piscataway",
		country: "USA",
		email: "KarenBurgess@jourrapide.com",
		firstContactNumber: "+12025550786",
		secondContactNumber: "+12025550125",
		patientAllergies: "none",
		patientBloodGroup: "A+",
		patientChronicCondition: "none",
		patientDateBrith: "02/09/1982",
		patientEmployer: "Keeney's",
		patientEmploymentStatus: "employee",
		patientGender: "female",
		patientId: "FG00012038",
		patientNationality: "United States of America",
		patientOccupation: "Musical instrument repairer",
		patientReligion: "Christian",
	},
	{
		id: "8.3",
		room: "8",
		parent: "room_8",
		bedNumber: "Bed 3",

		status: "occupied",
		patientName: "Morgan Carey",
		patientHeight: "1.85",
		patientWeight: "88",
		diagnosis: "Bronchitis",
		patientTemperature: 36.9,
		bloodPressure: "105/60",
		careRequired: "Post-operation care",
		doctor: "Sophia Matthews",
		admission: "12/12/2020",
		controls: ["edit", "clear"],

		insuranceType: "HSA",
		planNumber: "449876",
		policyHolderDate: "07/10/1987",
		policyHolderName: "Mary Schwartz",
		policyHolderRelationship: "daughter",
		policyIdNumber: "RSA3487982239",
		emergencyContactCity: "Buffalo",
		emergencyContactCountry: "USA",
		emergencyContactName: "Mary Schwartz",
		emergencyFirstContactNumber: "+12025564578",
		emergencySecondContactNumber: "+12025594579",
		relationship: "daughter",
		adress: "3715 Saint Marys Avenue Georgetown, New York (NY) 13072",
		city: "Georgetown",
		country: "USA",
		email: "MorganKlein@rhyta.com",
		firstContactNumber: "+12029607849",
		secondContactNumber: "+12029611832",
		patientAllergies: "none",
		patientBloodGroup: "O-",
		patientChronicCondition: "Bronchitis",
		patientDateBrith: "04/05/1979",
		patientEmployer: "Canal Villere",
		patientEmploymentStatus: "employee",
		patientGender: "male",
		patientId: "FG00012039",
		patientNationality: "United States of America",
		patientOccupation: "Motel desk clerk",
		patientReligion: "Christian",
	},
	{
		id: "8.4",
		room: "8",
		parent: "room_8",
		bedNumber: "Bed 4",

		status: "available",
		patientName: "-",
		patientHeight: "",
		patientWeight: "",
		diagnosis: "-",
		patientTemperature: "",
		bloodPressure: "",
		careRequired: "-",
		doctor: "-",
		admission: "",
		controls: ["edit", "clear"],
	},
	{
		id: "room_9",
		bedNumber: "Room 9",
	},
	{
		id: "9.1",
		room: "9",
		parent: "room_9",
		bedNumber: "Bed 1",

		status: "occupied",
		patientName: "Livio Cocci",
		patientHeight: "1.91",
		patientWeight: "80",
		diagnosis: "Pneumonia",
		patientTemperature: 37.3,
		bloodPressure: "90/60",
		careRequired: "Take samples",
		doctor: "Eloise Saunders",
		admission: "12/12/2020",
		controls: ["edit", "clear"],

		insuranceType: "POS",
		planNumber: "339827",
		policyHolderDate: "09/11/1962",
		policyHolderName: "Livio Cocci",
		policyHolderRelationship: "-",
		policyIdNumber: "CVM5698592035",
		emergencyContactCity: "Reno",
		emergencyContactCountry: "USA",
		emergencyContactName: "Alberto Cocci",
		emergencyFirstContactNumber: "+12025656907",
		emergencySecondContactNumber: "+12025956909",
		relationship: "son",
		adress: "4444 Wescam Court Reno, Nevada (NV) 89501",
		city: "Reno",
		country: "USA",
		email: "LivioCocci@rhyta.com",
		firstContactNumber: "+12025550232",
		secondContactNumber: "+12025550143",
		patientAllergies: "milk",
		patientBloodGroup: "A+",
		patientChronicCondition: "none",
		patientDateBrith: "09/11/1962",
		patientEmployer: "Merry-Go-Round",
		patientEmploymentStatus: "employee",
		patientGender: "male",
		patientId: "FG00012040",
		patientNationality: "Italy",
		patientOccupation: "Microeconomist",
		patientReligion: "Christian",
	},
	{
		id: "9.2",
		room: "9",
		parent: "room_9",
		bedNumber: "Bed 2",

		status: "occupied",
		patientName: "Aurelio C. Sosa",
		patientHeight: "1.7",
		patientWeight: "90",
		diagnosis: "Pneumonia",
		patientTemperature: 37.2,
		bloodPressure: "125/70",
		careRequired: "Take samples",
		doctor: "Eloise Saunders",
		admission: "12/12/2020",
		controls: ["edit", "clear"],

		insuranceType: "PPO",
		planNumber: "932720",
		policyHolderDate: "11/01/1975",
		policyHolderName: "Aurelio C. Sosa",
		policyHolderRelationship: "brother",
		policyIdNumber: "PLO0095681001",
		emergencyContactCity: "Millen",
		emergencyContactCountry: "USA",
		emergencyContactName: "Ernesto Hayes",
		emergencyFirstContactNumber: "+12020555194",
		emergencySecondContactNumber: "+12021555195",
		relationship: "friend",
		adress: "199 Sam Everett Rd Fort Fairfield, Maine(ME), 04742",
		city: "Fort Fairfield",
		country: "USA",
		email: "AurelioCSosa@teleworm.us",
		firstContactNumber: "+12025550108",
		secondContactNumber: "+12025550199",
		patientAllergies: "none",
		patientBloodGroup: "B-",
		patientChronicCondition: "none",
		patientDateBrith: "11/01/1975",
		patientEmployer: "Rose Records",
		patientEmploymentStatus: "employee",
		patientGender: "male",
		patientId: "FG00012041",
		patientNationality: "Brazil",
		patientOccupation: "Logging equipment operator",
		patientReligion: "Christian",
	},
	{
		id: "9.3",
		room: "9",
		parent: "room_9",
		bedNumber: "Bed 3",

		status: "occupied",
		patientName: "Marta M. Jones",
		patientHeight: "",
		patientWeight: "",
		diagnosis: "Pneumonia",
		patientTemperature: 38.0,
		bloodPressure: "140/80",
		careRequired: "Take samples",
		doctor: "Eloise Saunders",
		admission: "12/12/2020",
		controls: ["edit", "clear"],

		insuranceType: "HMO",
		planNumber: "777539",
		policyHolderDate: "08/03/1970",
		policyHolderName: "Peter Jones",
		policyHolderRelationship: "father",
		policyIdNumber: "ZPL002243547",
		emergencyContactCity: "Venice",
		emergencyContactCountry: "USA",
		emergencyContactName: "Peter Jones",
		emergencyFirstContactNumber: "+12029600099",
		emergencySecondContactNumber: "+12029600897",
		relationship: "father",
		adress: "1460 Brenner Park Dr Venice, Florida (FL), 34292",
		city: "Venice",
		country: "USA",
		email: "MartaMJones@dayrep.com",
		firstContactNumber: "+12029607654",
		secondContactNumber: "+12029611655",
		patientAllergies: "none",
		patientBloodGroup: "A+",
		patientChronicCondition: "none",
		patientDateBrith: "10/09/1992",
		patientEmployer: "Wonderland",
		patientEmploymentStatus: "contractor",
		patientGender: "female",
		patientId: "FG00012042",
		patientNationality: "United States of America",
		patientOccupation: "Librarian",
		patientReligion: "Christian",
	},
	{
		id: "9.4",
		room: "9",
		parent: "room_9",
		bedNumber: "Bed 4",

		status: "available",
		patientName: "-",
		patientHeight: "",
		patientWeight: "",
		diagnosis: "-",
		patientTemperature: "",
		bloodPressure: "",
		careRequired: "-",
		doctor: "-",
		admission: "",
		controls: ["edit", "clear"],
	},
	{
		id: "room_10",
		bedNumber: "Room 10",
	},
	{
		id: "10.1",
		room: "10",
		parent: "room_10",
		bedNumber: "Bed 1",

		status: "occupied",
		patientName: "Olivia Scott",
		patientHeight: "",
		patientWeight: "",
		diagnosis: "Unspecified",
		patientTemperature: 37.3,
		bloodPressure: "90/60",
		careRequired: "Take samples",
		doctor: "Theo Fisher",
		admission: "12/12/2020",
		controls: ["edit", "clear"],

		insuranceType: "PPO",
		planNumber: "345091",
		policyHolderDate: "08/03/1980",
		policyHolderName: "Mark Peterson",
		policyHolderRelationship: "husband",
		policyIdNumber: "ZNP102347646",
		emergencyContactCity: "West Shokan",
		emergencyContactCountry: "USA",
		emergencyContactName: "Mark Peterson",
		emergencyFirstContactNumber: "+12029607003",
		emergencySecondContactNumber: "+12029611002",
		relationship: "husband",
		adress: "4393 State 28a Rte #A West Shokan, New York(NY), 12494",
		city: "West Shokan",
		country: "USA",
		email: "o.scott@gmail.com",
		firstContactNumber: "+12029607561",
		secondContactNumber: "+12029611562",
		patientAllergies: "none",
		patientBloodGroup: "AB-",
		patientChronicCondition: "none",
		patientDateBrith: "12/03/1985",
		patientEmployer: "Scott & Associates",
		patientEmploymentStatus: "director",
		patientGender: "female",
		patientId: "FG00012020",
		patientNationality: "UK",
		patientOccupation: "Lawyer",
		patientReligion: "Christian",
	},
	{
		id: "10.2",
		room: "10",
		parent: "room_10",
		bedNumber: "Bed 2",

		status: "available",
		patientName: "-",
		patientHeight: "",
		patientWeight: "",
		diagnosis: "-",
		patientTemperature: "",
		bloodPressure: "",
		careRequired: "-",
		doctor: "-",
		admission: "",
		controls: ["edit", "clear"],
	},
	{
		id: "10.3",
		room: "10",
		parent: "room_10",
		bedNumber: "Bed 3",

		status: "available",
		patientName: "-",
		patientHeight: "",
		patientWeight: "",
		diagnosis: "-",
		patientTemperature: "",
		bloodPressure: "",
		careRequired: "-",
		doctor: "-",
		admission: "",
		controls: ["edit", "clear"],
	},
	{
		id: "10.4",
		room: "10",
		parent: "room_10",
		bedNumber: "Bed 4",

		status: "available",
		patientName: "-",
		patientHeight: "",
		patientWeight: "",
		diagnosis: "-",
		patientTemperature: "",
		bloodPressure: "",
		careRequired: "-",
		doctor: "-",
		admission: "",
		controls: ["edit", "clear"],
	},
];
